import classnames from 'classnames'
import { useId } from 'react'
// Utils

import styles from './sliderRangeItem.module.scss'

interface SliderRangeItemProps {
  title: string
  value: string
  sliderPercentage: number
  className?: string
  newPdpv2?: boolean
}

export const SliderRangeItem = ({ className = '', ...props }: SliderRangeItemProps) => {
  const wrapClasses = classnames(styles.sliderRangeWrap, className)
  const id = useId()
  return (
    <div className={wrapClasses}>
      <label className={styles.sliderRangeTitle} htmlFor={id}>
        {props.title}: {props.value}
      </label>
      <input
        type="range"
        min="0"
        max="100"
        value={props.sliderPercentage}
        className={classnames(styles.rangeSlider, { [styles.rangeSlider_newPdpv2 ?? '']: props.newPdpv2 })}
        disabled
        id={id}
      />
    </div>
  )
}

export default SliderRangeItem
